module.exports = __webpack_public_path__ + "media/EnBW_ODR_2020_Drohneaufnahmen.b8565ff2.mp4";